import moment from 'moment'
import api from '../../../services/segi/index'
import powerAppsApi from '../../../services/powerapps/index'

const segiHeaders = {
  'Content-Type': 'multipart/form-data',
  Accept: 'multipart/form-data',
}

const assertSegiTimesheetOk = (data, defaultMsg = 'Erro na operação.') => {
  if (data?.ok === false) {
    throw new Error(data.msg || defaultMsg)
  }
  if (typeof data === 'string') {
    const lower = data.toLowerCase()
    if (
      lower.includes('sobrepos')
      || lower.includes('conflito')
      || lower.includes('limite')
      || lower.includes('duração contínua')
      || lower.includes('duracao continua')
      || lower.includes('erro ao')
      || lower.includes('um erro')
    ) {
      throw new Error(data)
    }
  }
  return data
}

export const mesRangeFromMesRef = (mesRef) => {
  const m = moment(mesRef, 'YYYY-MM', true)
  return {
    dtIni: m.startOf('month').format('YYYY-MM-DD'),
    dtFim: m.endOf('month').format('YYYY-MM-DD'),
    mesMmYyyy: m.format('MM/YYYY'),
  }
}

export async function fetchListaPontos(graphId, dtIni, dtFim) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'lista_pontos')
  formData.append('dt_ini', dtIni)
  formData.append('dt_fim', dtFim)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fetchListaPontoAtiv(graphId, pontoId) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'lista_ponto_ativ')
  formData.append('ponto_id', String(pontoId))
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fetchPendenciasRh(userEmail, gerente = true) {
  const body = {
    acao: 'listar_pendencias_a_avaliar',
    user_email: userEmail,
    gerente: gerente ? 1 : 0,
  }
  const res = await powerAppsApi.post('/', body, { headers: segiHeaders })
  return res.data
}

export async function avaliarPendencia({ userEmail, pendId, pendTab, pendAprov, justificativa }) {
  const body = {
    acao: 'avaliar_pendencias',
    user_email: userEmail,
    pend_tab: pendTab,
    pend_id: pendId,
    pend_aprov: pendAprov,
    pend_justif: justificativa,
  }
  const res = await powerAppsApi.post('/', body, { headers: segiHeaders })
  return res.data
}

export async function aprovarPendenciasMes(pfId, mesMmYyyy) {
  const body = {
    acao: 'aprovar_pendencias_mes',
    pf_id: pfId,
    mes: mesMmYyyy,
  }
  const res = await powerAppsApi.post('/', body, { headers: segiHeaders })
  return res.data
}

export async function registrarFeriasColaborador(graphId, dataEntrada, dataSaida, justificativa) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'registra_ferias')
  formData.append('DataEntrada', dataEntrada)
  formData.append('DataSaida', dataSaida)
  formData.append('Justificativa', justificativa)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return assertSegiTimesheetOk(res.data, 'Erro ao registrar férias.')
}

export async function verificaSobreposicaoAusencia(graphId, {
  dataEntrada, dataSaida, horaEntrada, horaSaida,
}) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'verifica_sobreposicao')
  formData.append('Data', dataEntrada)
  formData.append('DataSaida', dataSaida)
  if (horaEntrada) formData.append('HoraEntrada', horaEntrada)
  if (horaSaida) formData.append('HoraSaida', horaSaida)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function registrarAtestadoColaborador(graphId, {
  dataEntrada, dataSaida, horaEntrada, horaSaida, justificativa, files = [],
}) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'registra_ausencia')
  formData.append('DataEntrada', `${dataEntrada} ${horaEntrada || '00:00'}`)
  formData.append('DataSaida', `${dataSaida} ${horaSaida || '23:59'}`)
  formData.append('Justificativa', justificativa)
  files.forEach((file, index) => {
    formData.append(`arquivo${index}`, file, file.name || 'file')
  })
  const res = await api.post('/', formData, { headers: segiHeaders })
  return assertSegiTimesheetOk(res.data, 'Erro ao registrar atestado.')
}

export async function fetchListaProjetos(graphId) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'lista_projetos')
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fetchListaAtividades(graphId, projetoId) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'lista_atividades')
  formData.append('projeto_id', projetoId)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function registrarAjustePonto(graphId, {
  data, dataEntrada, dataSaida, justificativa, items,
}) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'registra_saida')
  formData.append('retroativo', 'true')
  formData.append('Data', data)
  formData.append('DataEntrada', dataEntrada)
  formData.append('DataSaida', dataSaida)
  formData.append('Justificativa', justificativa)
  formData.append('items', JSON.stringify(items))
  const res = await api.post('/', formData, { headers: segiHeaders })
  return assertSegiTimesheetOk(res.data, 'Erro ao registrar ajuste de ponto.')
}

export async function fetchExtratoRhMes(graphId, mesMmYyyy) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'extrato_rh_mes')
  formData.append('mes', mesMmYyyy)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fetchExtratoRhHistorico(graphId) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'extrato_rh_historico')
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function cancelarPontoIndividual(graphId, mesMmYyyy) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'cancelar_ponto_individual')
  formData.append('mes', mesMmYyyy)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fecharPontoIndividual(graphId, mesMmYyyy, sobreescreve = false) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'fecha_ponto_individual')
  formData.append('mes', mesMmYyyy)
  formData.append('sobreescreve', sobreescreve ? '1' : '0')
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fecharPontosEmMassa(userGraphId, mesMmYyyy, sobreescreve = false) {
  const formData = new FormData()
  formData.append('id', userGraphId)
  formData.append('acao', 'fecha_ponto_rh')
  formData.append('mes', mesMmYyyy)
  formData.append('sobreescreve', sobreescreve ? '1' : '0')
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function lancarAbonoEmMassa(userGraphId, mesMmYyyy, dataIni, dataFim, justificativa) {
  const formData = new FormData()
  formData.append('id', userGraphId)
  formData.append('acao', 'lancar_abono_mes')
  formData.append('mes', mesMmYyyy)
  formData.append('data_ini', dataIni)
  formData.append('data_fim', dataFim)
  formData.append('justificativa', justificativa)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function registrarFeriadoColaborador(graphId, data, nome = 'Feriado') {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'registra_feriado')
  formData.append('data', data)
  formData.append('nome', nome)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return assertSegiTimesheetOk(res.data, 'Erro ao registrar feriado.')
}

export async function lancarFeriadoEmMassa(userGraphId, mesMmYyyy, data, nome = 'Feriado') {
  const formData = new FormData()
  formData.append('id', userGraphId)
  formData.append('acao', 'lancar_feriado_mes')
  formData.append('mes', mesMmYyyy)
  formData.append('data', data)
  formData.append('nome', nome)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fetchRhGraficos(mesMmYyyy) {
  const formData = new FormData()
  formData.append('acao', 'dashboard_rh_graficos')
  formData.append('mes', mesMmYyyy)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}

export async function fetchRhDetalhamento({ mesMmYyyy, dataIni, dataFim, pfId, projeto }) {
  const formData = new FormData()
  formData.append('acao', 'dashboard_rh_detalhamento')
  formData.append('mes', mesMmYyyy)
  formData.append('data_ini', dataIni)
  formData.append('data_fim', dataFim)
  if (pfId) formData.append('pf_id', String(pfId))
  if (projeto) formData.append('projeto', projeto)
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}
